var React = require('react');

function ArrowRightInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M23.25 5.49701H0.75","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M19.5 9.24701L23.25 5.49701L19.5 1.74701","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

ArrowRightInline.defaultProps = {"viewBox":"0 0 24 10","fill":"none"};

module.exports = ArrowRightInline;

ArrowRightInline.default = ArrowRightInline;
